<template>
    <div>
        <transition-component>
            <title-bar v-show="titleBarVisible" :routes="routes" @routerBack="routerBack"/>
        </transition-component>
        <app-main class="app-main"/>
    </div>
</template>

<script>
    import "../style/vab.scss"
    import "../style/element-variables.scss"

    import { authManager } from '@zhoujianhui/vip-core'
    import TitleBar from '../component/TitleBar'
    import AppMain from '../component/AppMain'
    import TransitionComponent from '../component/TransitionComponent'

    export default {
        name: "PageLayout",
        components: {
            TransitionComponent,
            TitleBar,
            AppMain
        },
        data() {
            return {
                routes: this.getBreadcrumb()
            }
        },
        watch: {
            $route() {
                this.routes = this.getBreadcrumb();
            }
        },
        beforeRouteLeave(to, from, next) {
            if (authManager.getCurrentUser() && ['/login','/account-password-login'].includes(to.path)) {
                next('/home');
            } else {
                next();
            }
        },
        computed: {
            titleBarVisible() {
                if (this.routes[0].meta.title === '首页') {
                    return false;
                } else {
                    return true;
                }
            }
        },
        methods: {
            getBreadcrumb() {
                return this.$route.matched.filter(
                    (item) => item.name && item.meta.title
                )
            },
            /**
             * Description 返回事件
             * Date 2022/8/4
             */
            routerBack() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app-main {
        padding-top: .6rem;
        box-sizing: border-box;
        position: absolute !important;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        min-height: 100vh;
        overflow-y: auto;
    }
</style>
